module.exports = __webpack_public_path__ + "static/media/roi-anxiety.3d7b72c4.png";